<form [formGroup]="userForm">
  <header class="flex w-full flex-col px-4 pb-4 pt-2">
    <div class="flex flex-row items-center justify-between">
      <div class="flex items-center gap-4">
        <p-button
          icon="pi pi-arrow-left"
          (onClick)="navigateBack()"
          [text]="true"
          [rounded]="true"
          pTooltip="Back to list"
        />
        <h1 class="text-2xl font-semibold text-greyscale-900">
          {{ editMode ? "Edit User" : "Create User" }}
        </h1>
      </div>
      <div class="flex items-center gap-4">
        <p-button
          label="Cancel"
          severity="secondary"
          (onClick)="navigateBack()"
        />
        <p-button
          [label]="editMode ? 'Save Changes' : 'Create User'"
          [icon]="editMode ? 'pi pi-check' : 'pi pi-plus'"
          (onClick)="submitForm()"
        />
      </div>
    </div>
    <p class="text-sm text-greyscale-600">
      {{
        editMode
          ? "Update user information and settings"
          : "Create a new user profile"
      }}
    </p>
  </header>
  <main class="p-4">
    <section class="mb-4 rounded-lg border border-gray-200 bg-white p-4">
      <h2 class="mb-4 text-lg text-primary-500">User Informations</h2>

      <!-- First Name -->
      <div class="mb-4">
        <label for="firstName" class="text-sm text-primary-500"
          >First Name</label
        >
        <input
          id="firstName"
          type="text"
          pInputText
          formControlName="firstName"
          [fluid]="true"
        />
      </div>

      <!-- Last Name -->
      <div class="mb-4">
        <label for="lastName" class="text-sm text-primary-500">Last Name</label>
        <input
          id="lastName"
          type="text"
          pInputText
          formControlName="lastName"
          [fluid]="true"
        />
      </div>

      <!-- Email -->
      <div class="mb-4">
        <label for="emails" class="text-sm text-primary-500">Email</label>
        <input
          id="emails"
          type="email"
          pInputText
          formControlName="email"
          [fluid]="true"
        />
      </div>

      <!-- Phone -->
      <div class="mb-4">
        <label for="phone" class="text-sm text-primary-500">Phone</label>
        <input
          id="phone"
          type="text"
          pInputText
          formControlName="phone"
          [fluid]="true"
        />
      </div>

      <!-- Role -->
      <div class="mb-4">
        <label for="role" class="text-sm text-primary-500">Role</label>
        <p-select
          id="role"
          [options]="[
            { label: 'Super admin', value: 'superAdmin' },
            { label: 'Admin', value: 'admin' },
            { label: 'User', value: 'user' },
          ]"
          formControlName="role"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'Select a role'"
          [showClear]="true"
          [styleClass]="'w-full'"
        ></p-select>
      </div>
      <!-- Company -->
      <label for="companyId" class="text-sm text-primary-500">Company</label>
      <p-select
        id="companyId"
        [options]="selectCompanyOptions"
        formControlName="companyId"
        [placeholder]="'Link user to a company'"
        [showClear]="true"
        [styleClass]="'w-full'"
        appendTo="body"
      ></p-select>
    </section>

    @if (editMode) {
      <section class="mb-4 rounded-lg border border-gray-200 bg-white p-4">
        <h2 class="mb-4 text-lg text-primary-500">Security</h2>
        <p class="mb-4 text-sm text-gray-600">
          Send a password reset link to this user's email address. The user will
          receive an email with instructions to set a new password.
        </p>
        <p-button
          label="Send Password Reset Email"
          icon="pi pi-key"
          severity="secondary"
          variant="outlined"
          (onClick)="triggerPasswordReset()"
          [loading]="isResettingPassword"
        />
      </section>

      <section class="mb-4 rounded-lg border border-error-200 bg-error-50 p-4">
        <h2 class="mb-4 text-lg text-error-700">Danger Zone</h2>
        <p class="mb-4 text-sm text-error-600">
          Permanently delete this user account. This action cannot be undone.
        </p>
        <p-button
          label="Delete User"
          icon="pi pi-trash"
          severity="danger"
          (onClick)="confirmDelete()"
          [loading]="isDeleting"
        />
      </section>
    }
  </main>
</form>
